import slice from './versionSlice';

export * from './versionSlice';
export default slice;
